var Operator = window.Operator || {};
Operator.blockEditors = Operator.blockEditors || {};

$.extend(Operator.blockEditors, {
    SchemeBrickModel: function (opts) {
        var editor = opts.editor
            , block = opts.block
            , blockElementId = block.attr('id')
            , form = editor.find('form')
            , targetRevisionSelectorContainer = form.find('.target-revision-selector')
            , schemeDropdown = form.find('[name="TargetSchemeId"]')
            , useTargetRevisionCheckbox = form.find('[name="UseTargetRevisionId"]')
            , targetRevisionDropdown = form.find('[name="TargetRevisionId"]');

        useTargetRevisionCheckbox.on('change', function(){
            if(useTargetRevisionCheckbox.is(':checked')){
                targetRevisionSelectorContainer.removeClass('hidden');
            } else{
                targetRevisionSelectorContainer.addClass('hidden');
            }
        });
        
        if(useTargetRevisionCheckbox.is(':checked')){
            targetRevisionSelectorContainer.removeClass('hidden');
        } else{
            targetRevisionSelectorContainer.addClass('hidden');
        }

        setTargetRevisionDropdownOpts(schemeDropdown.val());
        targetRevisionDropdown.val(targetRevisionDropdown.data('current'));
        
        schemeDropdown.on('change', function(){
            setTargetRevisionDropdownOpts(schemeDropdown.val());
        });
        
        form.on('submit', function () {
            var schemeId = schemeDropdown.val();
            var revisionId = targetRevisionDropdown.val();
        
            if(!useTargetRevisionCheckbox.is(':checked')){
                revisionId = undefined;
            }
            
            Operator.Layout.connectionManager.updateEndpointsFromScheme(blockElementId, schemeId, revisionId).then(
                function(){
                    MDB.Notify.bootstrapSuccess('Ports updated');
                },
                function(errors){
                    MDB.Notify.bootstrapDanger(errors);
                }
            );
        });
        
        function setTargetRevisionDropdownOpts(scheme){
            var schemeRevisions = schemeDropdown.data('revisions')[scheme];
            
            targetRevisionDropdown.html(
                $(MDB.objectToDropdown(schemeRevisions, {reverse: true})).html()
            );
        }
    }
});